import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import Alert from "react-s-alert";
import _ from "underscore";
import { useQuery, useMutation, queryCache } from 'react-query'

import PageLoading from "../../../components/Loading";
import { cleanObjectAndReturn } from "../../../helpers/cleanObject"
import { InputFloatingLabel, ImageUploadCustom, Select } from "../../../formik";

import { postSpeaker, getSpeaker, putSpeaker } from "./xhr";

const FormSpeaker = ({
  intl,
  match,
  history,
  embedded,
  closeModal,
}) => {
  const { isLoading, data: speaker } = useQuery(['speakers', match && match.params && match.params.id ], getSpeaker, {
    enabled: match && match.params && match.params.id,
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const editForm = match && match.params && match.params.id ? true : false;

  let submitButtonText = intl.formatMessage({
    id: "button.createSpeaker",
  });

  if (editForm) {
    submitButtonText = intl.formatMessage({
      id: "button.saveSpeaker",
    });
  }

  const titleOptions = [
    { value: "", label: "" },
    { value: "Mr.", label: "Mr." },
    { value: "Ms.", label: "Ms." },
    { value: "Mrs.", label: "Mrs." },
    { value: "Dr.", label: "Dr." },
    { value: "Pr.", label: "Pr." },
    { value: "Pre.", label: "Pre." },
    { value: "M.", label: "M." },
    { value: "Mme", label: "Mme" },
    { value: "M./Mme", label: "M./Mme" },
    { value: "Mr./Ms.", label: "Mr./Ms." },
  ];

  const [postSpeakerMutation] = useMutation(postSpeaker, {
    onSuccess: (createdSpeaker) => {
      if(queryCache.getQueryData('speakers')) {
        queryCache.setQueryData('speakers', speakers => speakers.concat([createdSpeaker]));
      }
      Alert.success(intl.formatMessage({ id: 'speaker.create-success' }));
      if (embedded) {
        closeModal();
      } else {
        history.push("/speakers");
      }
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })
  const addSpeaker = async (values) => {
    Alert.warning(intl.formatMessage({id: "speaker.creating"}));
    await postSpeakerMutation({ speaker: cleanObjectAndReturn(values) })
  };

  const [putSpeakerMutation] = useMutation(putSpeaker, {
    onSuccess: (updatedSpeaker) => {
      if(queryCache.getQueryData('speakers')) {
        queryCache.setQueryData('speakers', speakers => speakers
          .map(speaker => speaker._id === updatedSpeaker._id ? updatedSpeaker : speaker)
        )
      }
      queryCache.setQueryData(['speakers', updatedSpeaker._id], s => updatedSpeaker);
      Alert.success(intl.formatMessage({ id: 'speaker.update-success' }));
      if (embedded) {
        closeModal(updatedSpeaker);
      } else {
        history.push("/speakers");
      }
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const editSpeaker = async (values) => {
    Alert.warning(intl.formatMessage({id: "speaker.updating"}));
    await putSpeakerMutation({
      _id: match.params.id,
      speaker: _.pick(
        values,
        "title",
        "firstName",
        "lastName",
        "picture",
        "password",
        "email",
        "phone",
        "description",
      )
    })
  };

  const initialValues = editForm
    ? {
      ...speaker,
    }
    : {
      title: "Mr.",
      firstName: "",
      lastName: match && match.params && match.params.name ? match.params.name : '',
      picture: "",
      password: '',
      email: "",
      phone: "",
      description: "",
    };

  if(editForm && isLoading) {
    return <PageLoading />
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) =>
        editForm ? editSpeaker(values) : addSpeaker(values)
      }
      enableReinitialize={true}
    >
      {({ values }) => {
        return (
          <Form className="add-event-form floating-label-form">
            <Row>
              <Col md={8} lg={9}>
                <Row>
                  <Col md={2}>
                    <Field
                      component={Select}
                      name="title"
                      placeholder={intl.formatMessage({
                        id: "input.title",
                      })}
                      options={titleOptions}
                    />
                  </Col>
                  <Col md={5}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.firstname",
                      })}
                      label={intl.formatMessage({
                        id: "input.firstname",
                      })}
                      name="firstName"
                      id="firstName"
                      required
                    />
                  </Col>
                  <Col md={5}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.lastname",
                      })}
                      label={intl.formatMessage({
                        id: "input.lastname",
                      })}
                      name="lastName"
                      id="lastName"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <Field
                      component={InputFloatingLabel}
                      type="password"
                      placeholder={intl.formatMessage({
                        id: "input.password",
                      })}
                      label={intl.formatMessage({
                        id: "input.password",
                      })}

                      name="password"
                      id="password"
                    />
                  </Col>
                  <Col sm={4}>
                    <Field
                      component={InputFloatingLabel}
                      type="email"
                      placeholder={intl.formatMessage({
                        id: "input.email",
                      })}
                      label={intl.formatMessage({
                        id: "input.email",
                      })}
                      name="email"
                      id="email"
                      required
                    />
                  </Col>
                  <Col sm={4}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.phone",
                      })}
                      label={intl.formatMessage({
                        id: "input.phone",
                      })}
                      name="phone"
                      id="phone"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      as="textarea"
                      name="description"
                      id="description"
                      rows={4}
                      placeholder={intl.formatMessage({
                        id: "input.speaker.description",
                      })}
                      label={intl.formatMessage({
                        id: "input.speaker.description",
                      })}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="form-buttons m-t-30 m-b-30 text-center">
                      {embedded ? (
                        <Button
                          onClick={() => closeModal()}
                          className="btn-black"
                        >
                          {intl.formatMessage({
                            id: "button.back",
                          })}
                        </Button>
                      ) : (
                          <Link to="/speakers">
                            <Button className="btn-black">
                              {intl.formatMessage({
                                id: "button.back",
                              })}
                            </Button>
                          </Link>
                        )}
                      <Button
                        className="btn-custom m-l-20"
                        type="submit"
                      >
                        {submitButtonText}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Card className="img-upload bg-gray">
                  <Card.Body>
                    <Field
                      component={ImageUploadCustom}
                      id="picture"
                      name="picture"
                      defaultImage="/images/profile-ico-img.png"
                      accept="image/*"
                      buttonEmpty="label.uploadPhoto"
                      buttonUploaded={intl.formatMessage({
                        id: "label.logoUploaded",
                      })}
                      maxSize={
                        process.env.REACT_APP_IMAGE_FILE_SIZE_MAX
                      }
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default injectIntl(FormSpeaker);
